import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
} from '@mui/material';
import type { PlayerNameDisplayFormat, PlayerSortOrder, UserPreferences } from '../types';

type PlayerDisplayControlsProps = {
  userPreferences: UserPreferences;
  onChange: (patch: Partial<UserPreferences>) => void;
  showGroupBySex?: boolean;
  variant?: 'framed' | 'inline';
};

export function PlayerDisplayControls({ userPreferences, onChange, showGroupBySex = true, variant = 'framed' }: PlayerDisplayControlsProps) {
  const controls = (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Name Format</InputLabel>
        <Select
          label="Name Format"
          value={userPreferences.playerNameDisplayFormat}
          onChange={(event) => onChange({ playerNameDisplayFormat: event.target.value as PlayerNameDisplayFormat })}
        >
          <MenuItem value="first_last">First Last</MenuItem>
          <MenuItem value="last_first">Last, First</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel>Sorting</InputLabel>
        <Select
          label="Sorting"
          value={userPreferences.playerSortOrder}
          onChange={(event) => onChange({ playerSortOrder: event.target.value as PlayerSortOrder })}
        >
          <MenuItem value="first_name">First Name</MenuItem>
          <MenuItem value="last_name">Last Name</MenuItem>
        </Select>
      </FormControl>
      {showGroupBySex && (
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(userPreferences.groupPlayersBySex)}
              onChange={(event) => onChange({ groupPlayersBySex: event.target.checked })}
            />
          }
          label="Group by Gender"
        />
      )}
    </Stack>
  );

  if (variant === 'inline') return controls;

  return (
    <Paper variant="outlined" sx={{ p: 1.5 }}>
      {controls}
    </Paper>
  );
}
